<template>
    <div class="text-compare-suggestion">
        <text-compare v-if="suggestedText" @apply-changes="onApplyChanges" @ignore-changes="onIgnoreChanges" @revert-ignore="onRevertIgnore"
                :reference="refText" reference-title="Translation|Traduction" :before="aiSuggestion.original" :after="suggestedText"
                      :status="aiSuggestion.status" :reason="aiSuggestion.comparison" :text-diff="aiSuggestion"/>
    </div>
</template>

<script>
import TextCompare from "@components/editor/text-compare.vue";

export default {
    name: `text-compare-suggestion`,
    components: {TextCompare},
    props: {
        component: {type: Object}
    },
    computed: {
        translateLanguage() {
            return this.displayLanguage === `fr` ? `en` : `fr`;
        },
        refText() {
            if (this.$store.state.comparison.type === `translation`) {
                return this.component.getText(this.translateLanguage);
            } else {
                return this.component.getText(this.displayLanguage);
            }
        },
        aiSuggestion() {
            if (!this.$store.state.comparison.suggestions)
                return null;

            return this.$store.state.comparison.suggestions.find(c => c.id === this.component.id);
        },
        suggestedText() {
            if (!this.aiSuggestion)
                return null;

            return this.aiSuggestion.suggestion;
        }
    },
    methods: {
        onIgnoreChanges() {
            this.$set(this.aiSuggestion, `status`, `ignored`);
        },
        onRevertIgnore() {
            this.$set(this.aiSuggestion, `status`, `different`);
        },
        onApplyChanges() {
            this.$set(this.component.newText, this.displayLanguage, this.suggestedText);
            this.$set(this.aiSuggestion, `status`, `applied`);
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
